// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* vuex */
import store from './store'

/* axios */
import axios from './api'
// import api from './api/api'
import "amfe-flexible";

Vue.prototype.http = axios;
// Vue.prototype.api = api;

/* swiper */
// import Swiper from "swiper";
// import "swiper/css/swiper.min.css";

/* 重置样式 */
import './assets/css/reset.min.css'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
console.log(VueLazyload, 'VueLazyload')

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'
import './assets/css/fonts.css'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/NewHeader'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
// import { monitorZoom } from "@/utils/monitorZoom.js";
// const m = monitorZoom();
// if (window.screen.width * window.devicePixelRatio >= 3840) {
//   document.body.style.zoom = 100 / (Number(m) / 2); // 屏幕为 4k 时
// } else {
//   document.body.style.zoom = 100 / Number(m);
// }

Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js